var _circle, _circle2, _circle3, _circle4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.905,
    fill: "#0076FF",
    stroke: "white",
    strokeWidth: 2.18994
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#0076FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#paint0_linear_4019_404)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2F79F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4019_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0728 16.7375C38.2822 16.7375 39.2627 17.718 39.2627 18.9275L39.2627 31.3521L39.2627 35.8728C39.2627 37.821 36.9097 38.7994 35.5284 37.4255L31.4746 33.3935C31.1205 33.0413 30.6567 32.8207 30.1601 32.7683L18.6977 31.5589C17.5834 31.4413 16.7376 30.5016 16.7376 29.381L16.7376 18.9275C16.7376 17.718 17.718 16.7375 18.9275 16.7375L37.0728 16.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4302,
    y: 21.4302,
    width: 12.2011,
    height: 1.87709,
    rx: 0.938547,
    fill: "#2F79F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4302,
    y: 25.4973,
    width: 6.25698,
    height: 1.87709,
    rx: 0.938547,
    fill: "#2F79F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5645,
    y: 25.4973,
    width: 4.06704,
    height: 1.87709,
    rx: 0.938547,
    fill: "#2F79F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4019_404",
    x1: 28,
    y1: 0,
    x2: 8.2905,
    y2: 42.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0076FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ACCC2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4019_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2123,
    height: 21.2737,
    fill: "white",
    transform: "translate(17.0503 17.0503)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.ebd430264b084e0f7255754b47ed7ff5.svg";
export { ForwardRef as ReactComponent };